import { apiConfigured, fetchConfig } from './api.js'

/** @type {null | Promise<object> | object} */
let brandingPromise = null
let brandingCache = null

const FALLBACK = {
  organization_name: 'AGH Sistemas y Telecomunicaciones',
  support_email: 'soporte@aghsistemas.com',
  support_phone: '952441147',
  logo_url: '/favicon.png',
  portal_title: 'Centro de soporte',
  portal_welcome:
    'Red, WiFi, telefonía y videovigilancia de tu instalación. Si tienes contrato, entra a la derecha.',
  primary_color: '#0084ff',
  managing_company: {
    commercial_name: 'AGH Sistemas y Telecomunicaciones',
    website: 'https://aghsistemas.com',
  },
}

export function formatPhone(phone) {
  const d = String(phone || '').replace(/\D/g, '')
  if (d.length === 9) return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}`
  return phone || ''
}

export async function loadBranding() {
  if (brandingCache) return brandingCache
  if (brandingPromise) return brandingPromise

  brandingPromise = (async () => {
    if (!apiConfigured()) {
      brandingCache = FALLBACK
      return brandingCache
    }
    try {
      const data = await fetchConfig()
      brandingCache = { ...FALLBACK, ...(data.branding || {}) }
    } catch {
      brandingCache = FALLBACK
    }
    return brandingCache
  })()

  return brandingPromise
}

export function getBrandingSync() {
  return brandingCache || FALLBACK
}
